import { type AgeBand, ageBandSchema } from '@kidshub/contracts';

/**
 * The illustrations a child can be given.
 *
 * **This vocabulary is shared with the Kids App and belongs in the contract.**
 * The tablet draws the avatar from this key; if the two lists drift, a parent
 * picks an owl and the child gets a fallback shape. It lives here only because
 * track B may not edit `packages/contracts` — raised as a request to track A.
 *
 * Never a photograph: `SPEC.md §2.4` stores the least it can about a child, and
 * an uploaded face is the most.
 */
export const AVATAR_KEYS = ['fox', 'bear', 'owl', 'rabbit', 'whale', 'bee'] as const;

export type AvatarKey = (typeof AVATAR_KEYS)[number];

export const DEFAULT_AVATAR_KEY: AvatarKey = 'fox';

/** In the order a parent would read them, youngest first. */
export const AGE_BANDS: readonly AgeBand[] = ageBandSchema.options;
